import React, { useContext, useEffect, useState } from 'react'
import { ShareContext } from '../header';
import Axios from 'axios';
import filter from '../../helpers/Filter';

export default function Share(props) {

  const {docx, shareSupport, viewer} = props;
  const modal = useContext(ShareContext);
  const [search, setSearch] = useState([]);
  const [show, setShow] = useState(false);

  const auth_email = JSON.parse(localStorage.getItem('authData')).email;

  async function GetUsers(value)
  {
    if(value.trim() !== '')
    {
      const url = `https://docsserver.onrender.com/user/search/${value}`;
      let res = await Axios.get(url);
      //console.log(typeof(res.data));
      if(typeof(res.data) == 'object')
      {
        let dataz = await filter(docx.urlkey, res.data)
        setSearch(dataz);
        setShow(true);
      }
      else if(res)
      {
        setSearch([]);
        setShow(true);
      }
      else
      {
        setShow(false);
      }
    }
    else
    {
      setShow(false);
    }
  }

  //* Adding viewers to document 
  async function addViewer(user)
  {
    let data = {
      docId: docx.urlkey,
      userId: user._id
    }

    const url = 'https://docsserver.onrender.com/share/addViewer'
    let res = await Axios.post(url, data);
    if(res.data == 'ok')
    {
      setShow(false);
      setSearch([]);
      shareSupport();
    }

    else{
      //! Error must be handled here
    }
  }

  //* Adding Editors to the document
  async function addEditor(user)
  {
    let data = {
      docId: docx.urlkey,
      userId: user._id
    }

    const url = 'https://docsserver.onrender.com/share/addEditor'
    let res = await Axios.post(url, data);
    
    if(res.data == 'ok')
    {
      setShow(false);
      setSearch([]);
      shareSupport();
    }
    else{
      //! Error must be handled here
    }
  }


  //! Delete user access
  async function DeleteUser(viewer, user)
  {
    let data = {
      docId: docx.urlkey,
      userId: user._id
    }

    const viewUrl = 'https://docsserver.onrender.com/revoke/removeViewer';
    const editUrl = 'https://docsserver.onrender.com/revoke/removeEditor';

    let res = await Axios.post(viewer?viewUrl:editUrl, data);
    //console.log(res.data);
    if(res.data == 'deleted')
    {
      //console.log(res.data);
      shareSupport();
    }
    else
    {
      //! This must be handled here
    }
  }

  //! Updating user Privileges
  async function ChangePrivilege(toEditor, user)
  {
    let data = {
      docId: docx.urlkey,
      userId: user._id
    }

    const url1 = `https://docsserver.onrender.com/updateAccess/updateAsEditor`;
    const url2 = `https://docsserver.onrender.com/updateAccess/updateAsViewer`;

    let res = await Axios.post(toEditor?url1:url2, data);
    
    if(res.data == 'ok')
    {
      shareSupport();
    }
    else
    {
      //! Must be handled here
    }
  }

  return(
      <>
      <div
      className="justify-center items-center flex overflow-x-hidden overflow-y-auto fixed inset-0 z-50 outline-none focus:outline-none">
        <div className="relative w-auto my-6 mx-auto max-w-3xl">
          {/*content*/}
          <div className="border-0 rounded-lg shadow-lg relative flex flex-col w-full bg-white outline-none focus:outline-none">
          {/*header*/}
          <div className="flex items-center align-middle justify-between p-5 border-b border-solid border-slate-200 rounded-t">
            <h3 className="text-3xl font-semibold">
              🎯 People who can Access
            </h3>
            <button onClick={() => modal.setShare(false)} className="p-1 ml-6 border-0 text-black float-right text-3xl leading-none font-semibold outline-none focus:outline-none"><svg xmlns="http://www.w3.org/2000/svg" className="h-6 w-6 text-gray-400" viewBox="0 0 20 20" fill="currentColor">
              <path fillRule="evenodd" d="M4.293 4.293a1 1 0 011.414 0L10 8.586l4.293-4.293a1 1 0 111.414 1.414L11.414 10l4.293 4.293a1 1 0 01-1.414 1.414L10 11.414l-4.293 4.293a1 1 0 01-1.414-1.414L8.586 10 4.293 5.707a1 1 0 010-1.414z" clipRule="evenodd" />
            </svg>
          </button>
          </div>
          {/*body*/}
          <div className="relative p-6 flex-auto border">

              {viewer?"":<input type="text" className='w-full border-2 p-2' placeholder='Search here' onChange={(e) => GetUsers(e.target.value)}></input>}

              {show? <div className='absolute bg-slate-200 z-10 h-fit shadow-lg w-full left-0'>{search.length!=0? search.map(item => {
                if(item.email !== auth_email)
                {
                  return(
                    <div key={item._id} className='p-1 flex align-middle items-center justify-evenly mt-1 hover:shadow-md hover:cursor-pointer'>
                    <img src={item.img} className='w-10 h-10 rounded-full cursor-pointer'></img>
                    <div className='p-3'>
                      <p className=''>{item.name}</p>
                      <p className=''>{item.email}</p>
                    </div>
                    <div className='relative group'>
                      <button className='p-2 bg-blue-500 text-white font-semibold'>Add</button>
  
                      <div className='absolute bg-slate-200 hidden group-hover:block z-10'>
                        <ul>
                          <li className='px-6 py-2 hover:bg-slate-50 cursor-pointer border border-b-gray-400' onClick={() => addEditor(item)}>Editor</li>
                          <li className='px-6 py-2 hover:bg-slate-50 cursor-pointer border-b-gray-400' onClick={() => addViewer(item)}>Viewer</li>
                        </ul>
                      </div>
                    </div>
                  </div>
                  )
                }
              }):<div className='absolute bg-slate-600 font-semibold text-white z-10 h-fit shadow-lg w-full left-0 p-3 text-center'>☹️ No User's Found</div>}</div>: ""}

              <div className='w-full bg-blue-500 text-white mt-3 p-3 flex items-center justify-evenly'>
                  {viewer?<p>🔒 You can only view the Content's</p>:<><svg xmlns="http://www.w3.org/2000/svg" className="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2}>
                  <path strokeLinecap="round" strokeLinejoin="round" d="M8.684 13.342C8.886 12.938 9 12.482 9 12c0-.482-.114-.938-.316-1.342m0 2.684a3 3 0 110-2.684m0 2.684l6.632 3.316m-6.632-6l6.632-3.316m0 0a3 3 0 105.367-2.684 3 3 0 00-5.367 2.684zm0 9.316a3 3 0 105.368 2.684 3 3 0 00-5.368-2.684z" />
                </svg><p>Search and add People to access the Docx</p></>}
              </div>

              {/*Displaying existing users*/}
              {docx.viewers.map(item => {
                return(
                <div key={item._id} className='p-1 flex align-middle items-center justify-evenly hover:shadow-md hover:cursor-pointer'>
                  <img src={item.img} className='w-10 h-10 rounded-full cursor-pointer'></img>
                  <div className='p-3'>
                    <p className=''>{item.name}</p>
                    <p className=''>{item.email}</p>
                  </div>
                  <div className='relative group'>
                    <button className='p-2 bg-blue-500 text-white font-semibold'>Viewer</button>

                    {!viewer?<div className='absolute bg-slate-200 hidden group-hover:block z-10'>
                      <ul>
                        <li className='px-6 py-2 hover:bg-slate-50 cursor-pointer border border-b-gray-400' onClick={() => ChangePrivilege(true, item)}>Editor</li>
                        <li className='px-6 py-2 hover:bg-slate-50 cursor-pointer border-b-gray-400' onClick={() => DeleteUser(true, item)}>Delete</li>
                      </ul>
                    </div>:""}
                  </div>
                </div>
                )
              })}
              {/*Displaying existng editors*/}
              {docx.editors.map(item => {
                return(
                <div key={item._id} className='p-1 flex align-middle items-center justify-evenly hover:shadow-md hover:cursor-pointer'>
                  <img src={item.img} className='w-10 h-10 rounded-full cursor-pointer'></img>
                  <div className='p-3'>
                    <p className=''>{item.name}</p>
                    <p className=''>{item.email}</p>
                  </div>
                  <div className='relative group'>
                    <button className='p-2 bg-blue-500 text-white font-semibold'>Editor</button>

                    <div className='absolute bg-slate-200 hidden group-hover:block z-10'>
                      <ul>
                        {/* <li className='px-6 py-2 hover:bg-slate-50 cursor-pointer border border-b-gray-400'>Editor</li> */}
                        <li className='px-6 py-2 hover:bg-slate-50 cursor-pointer border-b-gray-400' onClick={() => ChangePrivilege(false, item)}>Viewer</li>
                        <li className='px-6 py-2 hover:bg-slate-50 cursor-pointer border-b-gray-400' onClick={() => DeleteUser(false, item)}>Delete</li>
                      </ul>
                    </div>
                  </div>
                </div>
                )
              })}
              

          </div>
          {/*footer*/}
          <div className="p-6 border-t border-solid border-slate-200 rounded-b">
          <p className='text-blue-500 font-bold text-xl'>Share as Link: </p>
          <p className='bg-slate-200 p-1'>{window.location.href}</p>
         </div>
        </div>
      </div>
    </div>
    <div className="opacity-25 fixed inset-0 z-40 bg-black"></div>
  </>
  );
}
